module.exports = __webpack_public_path__ + "media/images/new_home/down-arrow-black-b9a21685fa6f6fe7dea7dab1ce1af54a.png";